import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button/Button";
import Chip from "../../components/chip"

const styles = (theme) => ({
    content: {
        width: '90vw',
        margin: 'auto',
        marginTop: 50
    },
    box: {
        textAlign: 'left',
        marginBottom: 50
    },
    button: {
        // width: '15%',
        width: '30%',
        marginLeft: '2%'
    },
    inlineDiv: {
        marginTop: 20,
        marginBottom: 20,
    },
    subtitle: {
        display: 'inline',
        fontSize: 20,
        color: '#585858'
    },
    bootstrapInput: {
        borderRadius: 4,
        position: 'relative',
        width: '50%',
        marginRight: '5%',
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        fontSize: 18,
    },
});

const Input = (props) => {

    const {classes, keyword, search, changeKeyWord, setKeyWord, keywords, removeKeyWord, selectKeyWord} = props;

    return (
        <div className={classes.box}>
            <div>
                <div className={classes.inlineDiv}>
                    <h3 className={classes.subtitle}>KEYWORD</h3>
                </div>
                <div>
                    <input
                        value={keyword}
                        onChange={(e) => changeKeyWord(e.target.value)}
                        className={classes.bootstrapInput}
                    />
                    <Button variant="contained" className={classes.button} color={'primary'}
                            onClick={() => search(keyword)}>REGISTER</Button>
                    {/*<Button variant="contained" className={classes.button} color={'primary'}
                            onClick={() => setKeyWord(keyword)}>REGISTER</Button>*/}
                </div>
            </div>
            {/*<div>
                <div className={classes.inlineDiv}>
                    <h3 className={classes.subtitle}>SEARCH WORDS</h3>
                </div>
                <div>
                    <Chip keywords={keywords}  removeKeyWord={removeKeyWord} selectKeyWord={selectKeyWord}/>
                </div>
            </div>*/}
        </div>
    );
};

export default withStyles(styles)(Input);
